<template>
  <div class="public-content theme-management">
    <div class="region-title" style="background: #fff">字典管理</div>
    <div class="add-category" style="justify-content: space-between;padding: 20px;" v-permission="'pms:admin:theme:add'">
      <el-select v-model="value" placeholder="请选择" @change="change()">
        <el-option v-for="item in tableData" :key="item.dictKey" :label="item.dictKeyName" :value="item.dictKey">
        </el-option>
      </el-select>
      <el-button round type="primary" @click="addDict">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableDataQuery" style="width: 100%;margin-bottom: 20px;" row-key="id" border :row-class-name="rowClassName">
        <el-table-column width="200px" prop="id" label="字典编号"> </el-table-column>
        <el-table-column min-width="200px" prop="dictValue" label="字典名称"></el-table-column>
        <el-table-column min-width="200px" prop="dictCode" label="字典KEY"></el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template v-slot="scope">
            <span class="color-blue" v-permission="'pms:admin:theme:update'" @click="changeList('编辑', scope.row)">编辑<br></span>
            <span class="color-blue" v-permission="'pms:admin:theme:delete'" @click="deleteId = scope.row, deleteDialog = true">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <CombinedDialog ref="dialogRef" @addList="addCategory" @changeRemark="changeName" @delete="deleteTheme"></CombinedDialog> -->
    <!--    分页-->
    <!-- <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination> -->
    <!-- 编辑/添加 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible" width="30%">
      <div style="width:60%;margin:0 auto">
        <span>字典名称：</span>
        <el-input style="width:200px" v-model="dictValue" placeholder="请输入内容" maxlength="20"></el-input>
      </div>
      <div style="width:60%;margin:10px auto" v-if="title === '添加'">
        <span>字典KEY： </span>
        <el-input style="width:200px" v-model="dictKey" placeholder="请输入内容" maxlength="20"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDictKey">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该字典属性？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeList('删除', deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
// import VPagination from '@/components/Pagination/index.vue'
import { dictionaryList, dictionaryKeyList, dictionarySave, dictionaryUpdate, dictionaryRemove } from '@/api/pms'
export default {
  name: 'dictionary-management',
  // components: {
  //   CombinedDialog,
  //   VPagination
  // },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      title: '',
      choiceId: '',
      dictValue: '',
      dictKey: '',
      value: '',
      dialogVisible: false,
      tableData: [],
      tableDataQuery: [], // 查询的结果
      currentSelected: {} // 当前选中的一条数据
      // queryInfo: {
      //   pageNum: 1, // 当前显示第几页
      //   pageSize: 10, // 每一页显示条数
      //   total: 0
      // }
    }
  },
  created () {
    this.getDictionary()
  },
  methods: {
    addDict () {
      // 添加
      if (!this.value) {
        this.$message.error('请选择名称')
        return
      }
      this.title = '添加'
      this.dictValue = ''
      this.dictKey = ''
      // this.dictKeyName = ''
      this.type = 'add'
      this.dialogVisible = true
    },
    change () {
      console.log(this.value)
      this.dictionaryList(this.value)
    },
    dictionaryList (dictKey) {
      dictionaryList(dictKey).then(res => {
        if (res.data.success) {
          this.tableDataQuery = res.data.data
          for (let i = 0; i < this.tableDataQuery.length; i++) {
            this.tableDataQuery[i].operation = {
              edit: '编辑',
              delete: '删除'
            }
          }
        }
      })
    },
    addDictKey () {
      if (this.dictValue === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.type === 'edit') {
        // let obj = {
        //   deleted: this.currentSelected.deleted,
        //   dictCode: this.currentSelected.dictCode,
        //   dictKey: this.currentSelected.dictKey,
        //   dictKeyName: this.currentSelected.dictKeyName,
        //   dictValue: this.currentSelected.dictValue,
        //   id: this.currentSelected.id
        // }
        let obj = {
          dictValue: this.dictValue,
          id: this.currentSelected.id
        }
        dictionaryUpdate(obj).then(res => {
          if (res.data.success) {
            this.dictionaryList(this.value)
            this.$message.success('修改成功')
            this.dialogVisible = false
          }
        })
      } else if (this.type === 'add') {
        if (this.dictKey === '') {
          this.$message.error('请输入字典KEY')
          return
        }
        dictionarySave(this.value, this.dictValue, this.dictKey).then(res => {
          if (res.data.success) {
            this.dictionaryList(this.value)
            this.$message.success('添加成功')
            this.dialogVisible = false
          }
        })
      }
    },
    getDictionary (val) {
      // { pageNum: val.pageNum, pageSize: val.pageSize }
      dictionaryKeyList().then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
      // this.tableData[rowIndex].index = rowIndex
    },
    changeList (val, content) {
      this.choiceId = content.id
      if (val === '删除') {
        dictionaryRemove(content.id).then(res => {
          if (res.data.success) {
            this.dictionaryList(this.value)
            this.$message.success('删除成功')
            this.deleteDialog = false
          }
        })
      }
      if (val === '编辑') {
        this.title = '编辑'
        this.type = 'edit'
        this.dictValue = content.dictValue
        this.currentSelected = content
        this.dialogVisible = true
      }
    },
    primaryAdd () { },
    addCategory () { },
    changeName () { },
    changePage () { },
    deleteTheme () { }
  }
}
</script>
<style scoped lang="less"></style>
